import { ReassignUserAction } from "../enums"
import { ReassignUserReducerAction, ReassignUserReducerState } from "../types"
import { updateItem } from "./items"
import { loadings } from "./loadings"
import { changeReassignUserId, fillReassignRow } from "./reassign"
import { checkCanBossFollowUp, fillTrackingRow, selectAllUsers, selectUser } from "./tracking"

export const ressignUserReducer = (state: ReassignUserReducerState, action: ReassignUserReducerAction) => {
    switch (action.type) {
        case ReassignUserAction.FILL_REASSIGN_USER: {
            return fillReassignRow(state, action.payload)
        }
        case ReassignUserAction.FILL_TRACKING_USER: {
            return fillTrackingRow(state, action.payload)
        }
        case ReassignUserAction.CHANGE_REASSIGN_USER_ID: {
            return changeReassignUserId(state, action.payload)
        }
        case ReassignUserAction.UPDATE_ITEM: {
            return updateItem({ state, payload: action.payload })
        }
        case ReassignUserAction.LOADING: {
            return loadings({ state, payload: action.payload })
        }
        case ReassignUserAction.SELECT_USER: {
            return selectUser(state, action.payload)
        }
        case ReassignUserAction.SELECT_ALL_USER: {
            return selectAllUsers(state)
        }
        case ReassignUserAction.CHECK_CAN_BOSS_FOLLOW_UP: {
            return checkCanBossFollowUp(state)
        }
        default: return state
    }
}